export default "__VITE_ASSET__a1f2926c__"